"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialDataAttSearchModel = instanceOfMaterialDataAttSearchModel;
exports.MaterialDataAttSearchModelFromJSON = MaterialDataAttSearchModelFromJSON;
exports.MaterialDataAttSearchModelFromJSONTyped = MaterialDataAttSearchModelFromJSONTyped;
exports.MaterialDataAttSearchModelToJSON = MaterialDataAttSearchModelToJSON;
exports.MaterialDataAttSearchModelToJSONTyped = MaterialDataAttSearchModelToJSONTyped;
/**
 * Check if a given object implements the MaterialDataAttSearchModel interface.
 */
function instanceOfMaterialDataAttSearchModel(value) {
    return true;
}
function MaterialDataAttSearchModelFromJSON(json) {
    return MaterialDataAttSearchModelFromJSONTyped(json, false);
}
function MaterialDataAttSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'mdMaterialNo': json['mdMaterialNo'] == null ? undefined : json['mdMaterialNo'],
        'attCategory': json['attCategory'] == null ? undefined : json['attCategory'],
    };
}
function MaterialDataAttSearchModelToJSON(json) {
    return MaterialDataAttSearchModelToJSONTyped(json, false);
}
function MaterialDataAttSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'mdMaterialNo': value['mdMaterialNo'],
        'attCategory': value['attCategory'],
    };
}
